import { routerReducer } from "react-router-redux";
import { combineReducers } from "redux";
import { authReducer } from "./auth";
import { userReducer } from "./user";
import { premiumReducer } from "./premium";
import { sectionReducer } from "./section/reducer";

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  premium: premiumReducer,
  routing: routerReducer,
  section: sectionReducer
});



/** WEBPACK FOOTER **
 ** ./src/core/reducers.js
 **/